import { useQuery } from "@tanstack/react-query";
import { useGraphql } from "~/api-client";
import type { CartRecord } from "~/types";

const noCarts: CartRecord[] = [];
Object.freeze(noCarts);

export function useRecentCarts(
  locationRef: string,
  limit?: number,
): {
  carts: CartRecord[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  loading: boolean;
} {
  const { getRecentCarts } = useGraphql();
  const {
    error,
    isFetching: loading,
    data,
  } = useQuery({
    queryKey: ["get-recent-carts", locationRef, limit],
    queryFn: () => getRecentCarts(locationRef, limit ?? 1),
    refetchOnWindowFocus: false,
  });

  const carts = data?.ordering?.recentCarts || noCarts;

  return { loading, error, carts };
}
